import { InjectionToken } from '@angular/core';
import { TNumberPerSize } from '@df/core/df-core.interfaces';

export namespace NDfModuleImage {
    export const CONFIG = new InjectionToken<IConfig>('DF_MODULE_IMAGE_CONFIG', {
        providedIn: 'root',
        factory: () => ({
            placeholder: false,
            placeholderBlur: false
        })
    });

    export const PRELOADED_IMAGES = new InjectionToken<Set<string>>('DF_MODULE_IMAGE_PRELOADED_IMAGES', {
        providedIn: 'root',
        factory: () => new Set<string>()
    });

    export interface IConfig {
        placeholder?: string | boolean;
        placeholderBlur?: number | boolean;
        placeholderBackgroundColor?: string;
        placeholderError?: string;
    }

    export interface IImage {
        url: string;
        alt?: string;
        title?: string;
    }

    export interface ToImage {
        toImage: () => IImage;
    }

    /**
     * Old image directive
     */
    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_MODULE_IMAGE_OPTIONS', {
        providedIn: 'root',
        factory: () => ({
            ignorRetina: false,
            viewportTollerance: 300,
            viewportTolleranceHorizontal: [400, 1000, 1000, 1000]
        })
    });

    export interface IModuleOptions {
        placeholder?: string;
        ignorRetina: boolean;
        viewportTollerance: number | TNumberPerSize;
        viewportTolleranceHorizontal: number | TNumberPerSize;
    }
}
